import { motion } from "framer-motion";
import { CREDENTIALS } from "@/constants/testIds";

const STATS = [
  { value: "UAE & Africa", label: "Regional Focus" },
  { value: "20+", label: "Jurisdictions Advised" },
  { value: "Published", label: "Book Author" },
  { value: "Multi-Sector", label: "Industries Served" },
];

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};
const item = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } },
};

export const CredentialsStrip = () => {
  return (
    <section
      data-testid={CREDENTIALS.strip}
      className="bg-canvas border-b border-charcoal/10"
    >
      {/* Section heading */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-14 md:pt-16 pb-2">
        <div className="flex items-center gap-4 mb-6">
          <span className="h-px w-12 bg-gold" />
          <span className="font-sans text-[11px] tracking-[0.28em] uppercase text-forest">
            Why AMADI
          </span>
        </div>
        <h2
          data-testid="why-amadi-heading"
          className="font-serif text-[21px] md:text-[25px] lg:text-[34px] text-charcoal leading-tight"
        >
          What Sets AMADI Apart
        </h2>
      </div>

      {/* Positioning stats */}
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "0px 0px -80px 0px" }}
        className="max-w-[1400px] mx-auto grid grid-cols-2 md:grid-cols-4"
      >
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            data-testid={CREDENTIALS.stat}
            variants={item}
            className={`flex flex-col justify-end px-6 lg:px-10 py-8 md:py-10 border-charcoal/10 ${
              i !== STATS.length - 1 ? "md:border-r" : ""
            } ${i % 2 === 0 ? "border-r md:border-r" : ""} ${i < 2 ? "border-b md:border-b-0" : ""}`}
          >
            <span className="font-serif text-xl md:text-2xl lg:text-3xl text-forest leading-none">
              {s.value}
            </span>
            <span className="mt-3 font-sans text-[11px] tracking-[0.2em] uppercase text-charcoal/50">
              {s.label}
            </span>
          </motion.div>
        ))}
      </motion.div>

      {/* Merged editorial ticker band */}
      <div className="bg-forest py-2.5 md:py-3 overflow-hidden select-none">
        <p className="flex items-center justify-center text-center font-serif italic text-xs md:text-sm text-canvas/80">
          MIDDLE EAST &amp; AFRICA
          <span className="text-gold not-italic px-3 md:px-4">—</span>
          CROSS-BORDER COUNSEL
        </p>
      </div>
    </section>
  );
};
